var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.413 21L13.598 2.302a.721.721 0 0 0-1.248 0L1.535 21c-.275.53.072 1.13.627 1.13H23.79c.554 0 .901-.605.622-1.13zm-.622 2.571H2.166c-1.667 0-2.703-1.807-1.874-3.244L11.102 1.58C11.935.14 14 .14 14.85 1.581l10.81 18.746c.833 1.442-.212 3.244-1.87 3.244zm-9.553-4.326c0 .699-.563 1.262-1.238 1.262a1.265 1.265 0 0 1-1.285-1.262c0-.698.563-1.245 1.285-1.245a1.24 1.24 0 0 1 1.238 1.245zM12.174 7.71h1.6c.153 0 .226.126.226.29l-.294 8.821c-.004.179-.126.261-.27.261h-.924c-.144 0-.266-.082-.27-.261L11.904 8c-.005-.164.096-.29.27-.29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d3fc08d309884ee43a3043ca21fc3093.svg";
export { ForwardRef as ReactComponent };